// extracted by extract-css-chunks-webpack-plugin
module.exports = {"date":"_2Ch74p","articleLink":"_1u7KAp","heading":"_1TrQFM","text":"xipIgc"};